const chapter = {
  id: 'strategies-food-production',
  slug: 'strategies-food-production',
  subject: 'biology',
  subjectLabel: 'Biology',
  exam: 'NEET',
  title: {
    english: 'Strategies for Enhancement in Food Production',
        hindi: 'खाद्य उत्पादन में वृद्धि की रणनीतियाँ',
  },
  estReadMinutes: 50,
  difficulty: {
    english: 'Easy',
        hindi: 'आसान',
  },
  weightage: {
    english: '2-3 questions in NEET',
        hindi: 'NEET में 2-3 प्रश्न',
  },
  syllabusTags: ['Biology in Human Welfare', 'NEET', 'Class-12'],
  sections: [
    {
      id: 'animal-husbandry',
      title: {
        english: 'Animal Husbandry',
        hindi: 'पशुपालन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Agricultural practice of breeding & raising livestock — > **70 % of world livestock** in India + China; their contribution to world farm produce only 25 % → low productivity.',
        hindi: 'पशुधन के प्रजनन और पालन-पोषण की कृषि पद्धति - > **विश्व पशुधन का 70%** भारत + चीन में; विश्व कृषि उत्पादन में उनका योगदान केवल 25% है → कम उत्पादकता।',
            },
            {
              english: '**Dairy farm management** — quality + quantity of milk → selection of high-yielding + disease-resistant breeds; cattle housed well-ventilated, clean; cattle bathed; stringent cleanliness + hygiene during milking, storage & transport; regular veterinary inspection.',
        hindi: '**डेयरी फार्म प्रबंधन** — दूध की गुणवत्ता + मात्रा → अधिक उपज देने वाली + रोग प्रतिरोधी नस्लों का चयन; मवेशियों को अच्छी तरह हवादार, साफ-सुथरा रखा जाए; मवेशियों को नहलाया गया; दूध निकालने, भंडारण और परिवहन के दौरान कड़ी सफ़ाई + स्वच्छता; नियमित पशु चिकित्सा निरीक्षण.',
            },
            {
              english: '**Poultry farm management** — selection of disease-free + suitable breeds; proper + safe farm conditions; proper feed & water; hygiene & health care.',
        hindi: '**पोल्ट्री फार्म प्रबंधन** - रोग-मुक्त + उपयुक्त नस्लों का चयन; उचित + सुरक्षित कृषि स्थितियाँ; उचित चारा एवं पानी; स्वच्छता एवं स्वास्थ्य देखभाल।',
            },
          ],
        },
      ],
    },
    {
      id: 'animal-breeding',
      title: {
        english: 'Animal Breeding',
        hindi: 'पशु प्रजनन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Goal: ↑ yield + improve quality.',
        hindi: 'लक्ष्य: ↑ उपज + गुणवत्ता में सुधार।',
            },
            {
              english: '**Inbreeding** = mating of close relatives within same breed for 4-6 generations.',
        hindi: '**इनब्रीडिंग** = 4-6 पीढ़ियों तक एक ही नस्ल के करीबी रिश्तेदारों का संभोग।',
            },
            {
              english: '• Increases homozygosity; necessary to evolve **pure line**.',
        hindi: '• समयुग्मकता को बढ़ाता है; **शुद्ध रेखा** विकसित करना आवश्यक है।',
            },
            {
              english: '• Brings out harmful recessive genes (eliminated by selection).',
        hindi: '• हानिकारक अप्रभावी जीन को बाहर लाता है (चयन द्वारा समाप्त)।',
            },
            {
              english: '• Continued inbreeding → **inbreeding depression** (↓ fertility & productivity) — selected animals of same breed but unrelated then mated → fertility restored.',
        hindi: '• निरंतर अंतःप्रजनन → **अंतर्प्रजनन अवसाद** (↓ प्रजनन क्षमता और उत्पादकता) - एक ही नस्ल के चयनित जानवर लेकिन असंबद्ध फिर संभोग → प्रजनन क्षमता बहाल।',
            },
            {
              english: '**Outbreeding** = mating of unrelated animals; 3 types:',
        hindi: '**आउटब्रीडिंग** = असंबंधित जानवरों का संभोग; 3 प्रकार:',
            },
            {
              english: '• **Out-crossing** = mating within same breed but no common ancestors for 4-6 generations → progeny called **out-cross**; single out-cross often overcomes inbreeding depression.',
        hindi: '• **आउट-क्रॉसिंग** = एक ही नस्ल के भीतर संभोग लेकिन 4-6 पीढ़ियों तक कोई सामान्य पूर्वज नहीं → संतान को **आउट-क्रॉसिंग** कहा जाता है; सिंगल आउट-क्रॉस अक्सर इनब्रीडिंग डिप्रेशन पर काबू पा लेता है।',
            },
            {
              english: '• **Cross-breeding** = superior males of one breed × superior females of another (e.g. **Hisardale sheep** = Bikaneri ewes × Marino rams).',
        hindi: '• **क्रॉस-ब्रीडिंग** = एक नस्ल के श्रेष्ठ नर × दूसरे नस्ल की श्रेष्ठ मादा (जैसे **हिसारडेल भेड़** = बीकानेरी भेड़ × मेरिनो मेढ़े)।',
            },
            {
              english: '• **Inter-specific hybridisation** = males & females of two different but related species (e.g. **mule** = donkey × mare).',
        hindi: '• **अंतर-विशिष्ट संकरण** = दो अलग-अलग लेकिन संबंधित प्रजातियों के नर और मादा (जैसे **खच्चर** = गधा × घोड़ी)।',
            },
            {
              english: '**Controlled breeding** — by:',
        hindi: '**नियंत्रित प्रजनन** — द्वारा:',
            },
            {
              english: '• **AI (Artificial Insemination)** — semen from superior male injected into reproductive tract of selected female; overcomes problems of normal mating.',
        hindi: '• **एआई (कृत्रिम गर्भाधान)** - श्रेष्ठ पुरुष के वीर्य को चयनित महिला के प्रजनन पथ में इंजेक्ट किया जाता है; सामान्य संभोग की समस्याओं पर काबू पाता है।',
            },
            {
              english: '• **MOET (Multiple Ovulation Embryo Transfer Technology)** — cow given FSH-like hormone → 6-8 eggs (instead of 1) → mated with superior bull / artificially inseminated → embryos at 8-32 cell stage recovered & transferred to surrogate mothers; genetic mother used for next round.',
        hindi: '• **MOET (मल्टीपल ओव्यूलेशन एम्ब्रियो ट्रांसफर टेक्नोलॉजी)** - गाय को एफएसएच जैसा हार्मोन दिया गया → 6-8 अंडे (1 के बजाय) → बेहतर बैल के साथ संभोग / कृत्रिम रूप से गर्भाधान → 8-32 सेल चरण में भ्रूण को बरामद किया गया और सरोगेट माताओं को स्थानांतरित किया गया; अगले दौर के लिए आनुवंशिक माँ का उपयोग किया गया।',
            },
            {
              english: '• Successfully demonstrated in cattle, sheep, rabbits, buffaloes, mares.',
        hindi: '• मवेशियों, भेड़ों, खरगोशों, भैंसों, घोड़ियों में सफलतापूर्वक प्रदर्शन किया गया।',
            },
          ],
        },
      ],
    },
    {
      id: 'apiculture-fisheries',
      title: {
        english: 'Bee-keeping & Fisheries',
        hindi: 'मधुमक्खी पालन और मत्स्य पालन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Apiculture** = maintenance of hives of honeybees for honey production. Most common Indian species = ***Apis indica***. Other: *A. dorsata* (rock bee), *A. florea*, *A. mellifera* (Italian bee, most popular for commercial bee-keeping).',
        hindi: '**मधुमक्खीपालन** = शहद उत्पादन के लिए मधुमक्खियों के छत्ते का रखरखाव। सबसे आम भारतीय species = ***Apis indica***। अन्य: *ए. डोरसाटा* (रॉक मधुमक्खी), *ए. फ्लोरिया*, *ए. मेलिफ़ेरा* (इतालवी मधुमक्खी, व्यावसायिक मधुमक्खी पालन के लिए सबसे लोकप्रिय)।',
            },
            {
              english: 'Knowledge needed: nature & habit of bees, selection of pasture, catching & hiving swarms, management of hives during seasons, handling & collection of honey & beeswax.',
        hindi: 'आवश्यक ज्ञान: मधुमक्खियों की प्रकृति और आदत, चारागाह का चयन, झुंडों को पकड़ना और छत्ता बनाना, मौसम के दौरान छत्तों का प्रबंधन, शहद और मोम का प्रबंधन और संग्रहण।',
            },
            {
              english: 'Bees + flowering plants — bees are pollinators; orchards near apiaries → ↑ yield of fruits + ↑ honey.',
        hindi: 'मधुमक्खियाँ + फूल वाले पौधे - मधुमक्खियाँ परागणक हैं; मधुमक्खियों के पास के बगीचे → ↑ फलों की उपज + ↑ शहद।',
            },
            {
              english: '**Fisheries** — covers fishing, processing, marketing of fish, shellfish (prawn, crab, lobster), oysters, edible molluscs.',
        hindi: '**मत्स्य पालन** - इसमें मछली पकड़ने, प्रसंस्करण, मछली, शेलफिश (झींगा, केकड़ा, झींगा मछली), सीप, खाद्य मोलस्क का विपणन शामिल है।',
            },
            {
              english: '**Aquaculture** — production of useful aquatic plants & animals (esp. fish farming = **pisciculture**).',
        hindi: '**जलीय कृषि** - उपयोगी जलीय पौधों और जानवरों (विशेष रूप से मछली farming = **pisciculture**)) का उत्पादन।',
            },
            {
              english: 'Common freshwater fishes — *Catla, Rohu, Magur*. Marine — *Hilsa, Sardine, Mackerel, Pomfret*.',
        hindi: 'सामान्य मीठे पानी की मछलियाँ - *कतला, रोहू, मागुर*। समुद्री - *हिल्सा, सार्डिन, मैकेरल, पॉम्फ्रेट*।',
            },
            {
              english: '**Blue Revolution** — increase in production of fish & marine resources (parallel to Green Revolution).',
        hindi: '**नीली क्रांति** - मछली और समुद्री संसाधनों के उत्पादन में वृद्धि (हरित क्रांति के समानांतर)।',
            },
          ],
        },
      ],
    },
    {
      id: 'plant-breeding',
      title: {
        english: 'Plant Breeding',
        hindi: 'पादप प्रजनन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: 'Conventional plant breeding = purposeful manipulation of plant species in order to create desired plant types — better suited for cultivation, give better yields, disease resistant.',
        hindi: 'पारंपरिक पौधा प्रजनन = वांछित प्रकार के पौधे तैयार करने के लिए पौधों की प्रजातियों का उद्देश्यपूर्ण हेरफेर - खेती के लिए बेहतर अनुकूल, बेहतर पैदावार देना, रोग प्रतिरोधी।',
            },
            {
              english: 'Steps in plant breeding:',
        hindi: 'पौधों के प्रजनन के चरण:',
            },
            {
              english: '• **Collection of variability (germplasm)** — entire collection of all alleles for all genes in a given crop.',
        hindi: '• **परिवर्तनशीलता का संग्रह (जर्मप्लाज्म)** - किसी फसल में सभी जीनों के लिए सभी एलील्स का संपूर्ण संग्रह।',
            },
            {
              english: '• **Evaluation & selection of parents**.',
        hindi: '• **माता-पिता का मूल्यांकन एवं चयन**।',
            },
            {
              english: '• **Cross-hybridisation** of selected parents.',
        hindi: '• चयनित माता-पिता का **क्रॉस-हाइब्रिडाइजेशन**।',
            },
            {
              english: '• **Selection & testing of superior recombinants**.',
        hindi: '• **बेहतर पुनः संयोजकों का चयन और परीक्षण**।',
            },
            {
              english: '• **Testing, release & commercialisation** of new cultivars.',
        hindi: '• **नई किस्मों का परीक्षण, विमोचन और व्यावसायीकरण**। **हरित क्रांति** - पौधों के प्रजनन में सफलता पर निर्भर → 20वीं सदी के मध्य में गेहूं और चावल की विकसित किस्में।',
            },
            {
              english: '**Green Revolution** — depended on success in plant breeding → developed varieties of wheat & rice in mid-20th century.',
        hindi: '**हरित क्रांति** - पौधों के प्रजनन में सफलता पर निर्भर → 20वीं सदी के मध्य में गेहूं और चावल की विकसित किस्में।',
            },
            {
              english: '• **Wheat** — semi-dwarf, high-yielding (Norman Borlaug at CIMMYT, Mexico — Nobel Peace 1970). Indian varieties — **Sonalika, Kalyan Sona**. Output rose from 11 → 75 mt (1960-2000).',
        hindi: '• **गेहूं** - अर्ध-बौना, अधिक उपज देने वाला (CIMMYT, मैक्सिको में नॉर्मन बोरलॉग - नोबेल शांति 1970)। भारतीय किस्में - **सोनालिका, कल्याण सोना**। उत्पादन 11 → 75 मिलियन टन (1960-2000) तक बढ़ गया।',
            },
            {
              english: '• **Rice** — semi-dwarf from IRRI, Philippines (IR-8). Indian semi-dwarf — **Jaya, Ratna**.',
        hindi: '• **चावल** - आईआरआरआई, फिलीपींस से अर्ध-बौना (आईआर-8)। भारतीय अर्ध-बौना - **जया, रत्ना**।',
            },
            {
              english: '• **Sugarcane** — *Saccharum barberi* (N India, low sugar) × *S. officinarum* (S India, thick stem, high sugar) → high-yield + high sugar varieties suited for both regions.',
        hindi: '• **गन्ना** - *सैकेरम बारबेरी* (उत्तरी भारत, कम चीनी) × *एस. ऑफिसिनारम* (दक्षिणी भारत, मोटा तना, अधिक चीनी) → उच्च उपज + उच्च चीनी वाली किस्में दोनों क्षेत्रों के लिए उपयुक्त हैं।',
            },
            {
              english: '• **Millets** — hybrid maize, jowar, bajra developed in India.',
        hindi: '• **बाजरा** - संकर मक्का, ज्वार, बाजरा भारत में विकसित हुआ।',
            },
          ],
        },
      ],
    },
    {
      id: 'breeding-resistance',
      title: {
        english: 'Breeding for Disease & Pest Resistance',
        hindi: 'रोग और पीड़क प्रतिरोधक प्रजनन',
      },
      blocks: [
        {
          type: 'table',
          headers: ['Crop', 'Variety', 'Resistance to'],
          rows: [
            ['Wheat', 'Himgiri', 'Leaf & stripe rust, hill bunt'],
            ['Brassica', 'Pusa Swarnim (Karan rai)', 'White rust'],
            ['Cauliflower', 'Pusa Shubhra, Pusa Snowball K-1', 'Black rot, curl blight black rot'],
            ['Cowpea', 'Pusa Komal', 'Bacterial blight'],
            ['Chilli', 'Pusa Sadabahar', 'Chilli mosaic virus, TMV, leaf curl'],
            ['Brassica (insect)', 'Pusa Gaurav', 'Aphids'],
            ['Flat bean', 'Pusa Sem 2 / Pusa Sem 3', 'Jassids, aphids, fruit borer'],
            ['Okra (lady\'s finger)', 'Pusa Sawani / Pusa A-4', 'Shoot & fruit borer'],
          ],
        },
      ],
    },
    {
      id: 'biofortification-spm-tissue-culture',
      title: {
        english: 'Biofortification, SCP & Tissue Culture',
        hindi: 'जैव-सम्पुष्टि, SCP और ऊतक संवर्धन',
      },
      blocks: [
        {
          type: 'list',
          items: [
            {
              english: '**Biofortification** = breeding crops with higher levels of vitamins, minerals, proteins, healthier fats. Practical means to improve public health.',
        hindi: '**बायोफोर्टिफिकेशन** = विटामिन, खनिज, प्रोटीन, स्वस्थ वसा के उच्च स्तर के साथ फसलों का प्रजनन। सार्वजनिक स्वास्थ्य में सुधार के व्यावहारिक साधन।',
            },
            {
              english: 'Examples — protein-enriched **maize hybrid (2000)** with twice essential amino acids (lysine, tryptophan); **wheat Atlas 66** (high-protein); **iron-rich rice** (5 × normal); **carrot, spinach, pumpkin** (rich in vitamin A); **bitter gourd, mustard, tomato** (rich in vitamin C); **broccoli** (Ca, Fe).',
        hindi: 'उदाहरण - प्रोटीन-समृद्ध **मक्का संकर (2000)** दो बार आवश्यक अमीनो एसिड (लाइसिन, ट्रिप्टोफैन) के साथ; **गेहूं एटलस 66** (उच्च-प्रोटीन); **आयरन युक्त चावल** (5 × सामान्य); **गाजर, पालक, कद्दू** (विटामिन ए से भरपूर); **करेला, सरसों, टमाटर** (विटामिन सी से भरपूर); **ब्रोकोली** (Ca, Fe)।',
            },
            {
              english: '**Single Cell Protein (SCP)** = microbes grown to produce protein-rich biomass to combat malnutrition.',
        hindi: '**एकल कोशिका प्रोटीन (एससीपी)** = कुपोषण से निपटने के लिए प्रोटीन युक्त बायोमास का उत्पादन करने के लिए उगाए गए रोगाणु।',
            },
            {
              english: '• ***Spirulina*** can be grown on materials like waste water from potato processing plants → produces large quantities rich in protein, minerals, fats, carbohydrates, vitamins.',
        hindi: '• ***स्पिरुलिना*** को आलू प्रसंस्करण संयंत्रों से अपशिष्ट जल जैसी सामग्री पर उगाया जा सकता है → यह बड़ी मात्रा में प्रोटीन, खनिज, वसा, कार्बोहाइड्रेट, विटामिन से भरपूर होता है।',
            },
            {
              english: '• ***Methylophilus methylotrophus*** (high biomass production rate + protein) → can produce **25 tonnes of protein** from 250 g of microorganisms.',
        hindi: '• ***मिथाइलोफिलस मिथाइलोट्रोफस*** (उच्च बायोमास उत्पादन दर + प्रोटीन) → 250 ग्राम सूक्ष्मजीवों से **25 टन प्रोटीन** का उत्पादन कर सकता है।',
            },
            {
              english: 'Mushrooms (e.g. *Morchella esculenta* = morel) are also edible; recently used as SCP source.',
        hindi: 'मशरूम (उदाहरण के लिए *मोर्चेला एस्कुलेंटा* = मोरेल) भी खाने योग्य हैं; हाल ही में एससीपी स्रोत के रूप में उपयोग किया गया।',
            },
            {
              english: '**Tissue culture** — capacity to generate whole plant from any cell of plant = **totipotency** (Haberlandt).',
        hindi: '**ऊतक संवर्धन** — plant = **totipotency** (Haberlandt) की किसी भी कोशिका से पूरा पौधा उत्पन्न करने की क्षमता।',
            },
            {
              english: '• Explant grown in **Murashige-Skoog (MS) medium** with auxin + cytokinin → undifferentiated **callus** → differentiation → plantlets.',
        hindi: '• **मुराशिगे-स्कूग (एमएस) माध्यम** में ऑक्सिन + साइटोकिनिन → अविभेदित **कैलस** → विभेदन → पौधे के साथ उगाए गए एक्सप्लांट।',
            },
            {
              english: '• **Micropropagation** — production of thousands of plants in short duration (tomato, banana, apple grown commercially).',
        hindi: '• **सूक्ष्मप्रवर्धन** - कम अवधि में हजारों पौधों का उत्पादन (टमाटर, केला, सेब व्यावसायिक रूप से उगाया जाता है)।',
            },
            {
              english: '• **Somatic hybridisation** — fusion of protoplasts from two different varieties (cell wall removed by **cellulase + pectinase**) → **somatic hybrid** (e.g. **Pomato** = potato + tomato — could not be commercialised).',
        hindi: '• **दैहिक संकरण** - दो अलग-अलग किस्मों के प्रोटोप्लास्ट का संलयन (**सेल्यूलेज + पेक्टिनेज** द्वारा हटाई गई कोशिका भित्ति) → **दैहिक संकर** (उदाहरण के लिए **पोमाटो** = आलू + टमाटर - का व्यवसायीकरण नहीं किया जा सका)।',
            },
            {
              english: '• **Virus-free plants** — meristem (apical & axillary) is virus-free even if plant is infected → recovered + cultured (banana, sugarcane, potato).',
        hindi: '• **वायरस-मुक्त पौधे** - मेरिस्टेम (एपिकल और एक्सिलरी) वायरस-मुक्त होते हैं, भले ही पौधा संक्रमित हो → पुनर्प्राप्त + संवर्धित (केला, गन्ना, आलू)।',
            },
          ],
        },
      ],
    },
  ],
  keyFormulas: [
    {
      latex: '\\text{Inbreeding} \\rightarrow \\text{pure line; depression after generations}',
      desc: {
        english: '',
        hindi: 'इनब्रीडिंग शुद्ध रेखा; पीढ़ियों के बाद अवसाद',
      },
    },
    {
      latex: '\\text{Hisardale = Bikaneri ewes} \\times \\text{Marino rams (cross-breed)}',
      desc: {
        english: '',
        hindi: 'हिसारडेल = बीकानेरी ईव्स मैरिनो मेढ़े (क्रॉस-ब्रीड)',
      },
    },
    {
      latex: '\\text{MOET: 6-8 embryos transferred per superior cow per breeding}',
      desc: {
        english: '',
        hindi: 'MOET: प्रति प्रजनन प्रति श्रेष्ठ गाय में 6-8 भ्रूण स्थानांतरित किए जाते हैं',
      },
    },
    {
      latex: '\\text{Apis mellifera (Italian bee) — most commercial}',
      desc: {
        english: '',
        hindi: 'एपिस मेलिफ़ेरा (इतालवी मधुमक्खी) - सबसे व्यावसायिक',
      },
    },
    {
      latex: '\\text{Green Revolution: Sonalika, Kalyan Sona (wheat); Jaya, Ratna (rice)}',
      desc: {
        english: '',
        hindi: 'हरित क्रांति: सोनालिका, कल्याण सोना (गेहूं); जया, रत्ना (चावल)',
      },
    },
    {
      latex: '\\text{Saccharum officinarum (S India, sweet)} \\times \\text{S. barberi (N India)}',
      desc: {
        english: '',
        hindi: 'सैकरम ऑफ़िसिनारम (दक्षिण भारत, मीठा) एस. बारबेरी (उत्तर भारत)',
      },
    },
    {
      latex: '\\text{Spirulina, Methylophilus methylotrophus = SCP}',
      desc: {
        english: '',
        hindi: 'स्पिरुलिना, मिथाइलोफिलस मिथाइलोट्रोफस = एससीपी',
      },
    },
  ],
  pyqs: [
    {
      year: 2024,
      exam: 'NEET',
      tag: 'Hybrid',
      problem: {
        english: 'Hisardale is a cross-breed of:',
        hindi: 'हिसरडेल किसकी संकर नस्ल है:',
      },
      answer: {
        english: 'Bikaneri ewes × Marino rams',
        hindi: 'बीकानेरी ईव्स × मैरिनो मेढ़े',
      },
      solution: {
        english: 'Cross-breeding (between superior animals of two breeds).',
        hindi: 'क्रॉस-ब्रीडिंग (दो नस्लों के श्रेष्ठ जानवरों के बीच)।',
      },
    },
    {
      year: 2023,
      exam: 'NEET',
      tag: 'Bee',
      problem: {
        english: 'Most common Italian honey bee for commercial apiculture is:',
        hindi: 'वाणिज्यिक मधुमक्खी पालन के लिए सबसे आम इतालवी मधुमक्खी है:',
      },
      answer: {
        english: 'Apis mellifera',
        hindi: 'एपिस मेलिफ़ेरा',
      },
      solution: {
        english: 'High honey collection, gentle, prolific breeder.',
        hindi: 'उच्च शहद संग्रहण, सौम्य, विपुल प्रजनक।',
      },
    },
    {
      year: 2022,
      exam: 'NEET',
      tag: 'MOET',
      problem: {
        english: 'In MOET technology, hormone administered for super-ovulation is similar to:',
        hindi: 'MOET तकनीक में, सुपर-ओव्यूलेशन के लिए प्रशासित हार्मोन इसके समान है:',
      },
      answer: {
        english: 'FSH',
        hindi: 'एफएसएच',
      },
      solution: {
        english: '6-8 eggs released instead of normal one.',
        hindi: 'सामान्य अंडे के बजाय 6-8 अंडे निकले।',
      },
    },
    {
      year: 2021,
      exam: 'NEET',
      tag: 'Tissue culture',
      problem: {
        english: 'Pomato is a hybrid produced by:',
        hindi: 'पोमाटो एक संकर है जिसका उत्पादन होता है:',
      },
      answer: {
        english: 'Somatic hybridisation (potato + tomato protoplasts)',
        hindi: 'दैहिक संकरण (आलू + टमाटर प्रोटोप्लास्ट)',
      },
      solution: {
        english: 'Could not be commercialised.',
        hindi: 'व्यावसायीकरण नहीं किया जा सका।',
      },
    },
    {
      year: 2018,
      exam: 'NEET',
      tag: 'SCP',
      problem: {
        english: 'Methylophilus methylotrophus is used as a source of:',
        hindi: 'मिथाइलोफिलस मिथाइलोट्रॉफ़स का उपयोग इसके स्रोत के रूप में किया जाता है:',
      },
      answer: {
        english: 'Single Cell Protein (SCP)',
        hindi: 'एकल कोशिका प्रोटीन (एससीपी)',
      },
      solution: {
        english: '250 g microbes → ~25 tonnes of protein.',
        hindi: '250 ग्राम रोगाणु → ~25 टन प्रोटीन।',
      },
    },
  ],
  next: {
    slug: 'environmental-issues',
    title: 'Environmental Issues',
  },
};

export default chapter;
